import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import AUHeader from '../components/AUHeader';

const LOOM_EMBED_URL = 'https://www.loom.com/embed/855e0f42a9ba4d3b847f6b98625809eb';

const NutritionOnePage = () => {
  return (
    <Box sx={{ bgcolor: '#fff', fontFamily: 'Kanit, sans-serif', minHeight: '100vh' }}>
      <AUHeader />

      <Box sx={{ pt: { xs: 4, md: 6 }, pb: { xs: 5, md: 8 } }}>
        <Container maxWidth="lg">
          <Typography sx={{
            fontSize: 15, fontWeight: 700, letterSpacing: 2.5,
            color: '#1A7FFF', textTransform: 'uppercase',
            mb: 0.75, fontFamily: 'Kanit, sans-serif',
          }}>
            Antes de la llamada
          </Typography>
          <Typography component="h1" sx={{
            fontFamily: 'Kanit, sans-serif', fontWeight: 800,
            fontSize: { xs: '2.2rem', md: '3rem' },
            color: '#0F1117', mb: 3,
          }}>
            ¿Cómo funciona AU Coaching?
          </Typography>

          <Box sx={{
            position: 'relative', paddingBottom: '56.25%', height: 0,
            overflow: 'hidden', borderRadius: 3,
            boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
          }}>
            <iframe
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
              src={LOOM_EMBED_URL}
              title="¿Cómo funciona AU Coaching?"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default NutritionOnePage;
